// /home/szymon/kreator2/frontend/src/components/editor/hooks/useEditorZoom.js
// v1.0.0 – Hook odpowiedzialny za obliczanie i obsługę zoomFactor (auto-zoom)

import { useState, useEffect, useCallback, useMemo } from "react";

export function useEditorZoom({ pages, currentPage }) {
  const [zoomFactors, setZoomFactors] = useState([]);

  // Obliczanie auto-zoom dla strony
  function computeAutoZoom(pageWidth, pageHeight) {
    const LEFT_TOOLBAR_WIDTH = 70;
    const SIDE_PANEL_WIDTH = 300;
    const TOPBAR_HEIGHT = 60;
    const EXTRA_MARGIN = 80;
    const availableW =
      window.innerWidth - LEFT_TOOLBAR_WIDTH - SIDE_PANEL_WIDTH - EXTRA_MARGIN;
    const availableH = window.innerHeight - TOPBAR_HEIGHT - EXTRA_MARGIN;
    if (availableW < 10 || availableH < 10) {
      return 0.1;
    }
    const scale = Math.min(availableW / pageWidth, availableH / pageHeight);
    return Math.max(scale, 0.1);
  }

  // Gdy zmieniają się strony -> wylicz nowy zoom
  useEffect(() => {
    if (!pages || pages.length === 0) {
      setZoomFactors([]);
      return;
    }
    const newZooms = pages.map((pg) =>
      computeAutoZoom(pg.baseWidth, pg.baseHeight)
    );
    setZoomFactors(newZooms);
  }, [pages]);

  const currentZoom = useMemo(() => {
    if (!pages || pages.length === 0) return 1;
    if (currentPage >= pages.length) return 1;
    return zoomFactors[currentPage] || 1;
  }, [pages, zoomFactors, currentPage]);

  // Zmiana zoomu na aktualnej stronie
  const handleZoomChange = useCallback(
    (newVal) => {
      setZoomFactors((prev) => {
        const arr = [...prev];
        if (currentPage < arr.length) {
          arr[currentPage] = newVal;
        }
        return arr;
      });
    },
    [currentPage]
  );

  return {
    currentZoom,
    handleZoomChange
  };
}
